import { render, staticRenderFns } from "./BilletItems.vue?vue&type=template&id=7224aed1&scoped=true"
import script from "./BilletItems.vue?vue&type=script&lang=js"
export * from "./BilletItems.vue?vue&type=script&lang=js"
import style0 from "./BilletItems.vue?vue&type=style&index=0&id=7224aed1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7224aed1",
  null
  
)

export default component.exports